import { CalendarBlank, CurrencyCircleDollar, Lightning, Lightbulb, MagnifyingGlass, Robot } from '@phosphor-icons/react';

const RecommendationIcon = ({ icon }) => {
  const iconMap = {
    money: <CurrencyCircleDollar size={20} weight="duotone" />,
    calendar: <CalendarBlank size={20} weight="duotone" />,
    search: <MagnifyingGlass size={20} weight="duotone" />,
    lightning: <Lightning size={20} weight="duotone" />,
  };
  return iconMap[icon] || <Lightbulb size={20} weight="duotone" />;
};

export const AIRecommendations = ({ recs }) => (
  <div className="lg:col-span-3 bg-white border border-[#f2f4f6] rounded-2xl p-6" data-testid="ai-recommendations">
    <div className="flex items-center gap-2 mb-5">
      <Lightbulb size={18} className="text-[#005bc1]" weight="fill" />
      <span className="text-[#005bc1] text-xs font-bold uppercase tracking-widest">AI Recommendations</span>
    </div>

    {recs.length > 0 ? (
      <div className="grid sm:grid-cols-2 gap-4">
        {recs.map((rec, i) => {
          const bgColors = ['bg-[#f0fdf4]', 'bg-[#eff6ff]', 'bg-[#fefce8]', 'bg-[#fdf4ff]'];
          const textColors = ['text-[#065f46]', 'text-[#1e40af]', 'text-[#854d0e]', 'text-[#86198f]'];
          const iconBgs = ['bg-[#d1fae5]', 'bg-[#dbeafe]', 'bg-[#fef3c7]', 'bg-[#f5d0fe]'];

          return (
            <div key={i} className={`${bgColors[i % 4]} rounded-xl p-4 hover:shadow-sm transition-shadow`} data-testid={`recommendation-${i}`}>
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-lg ${iconBgs[i % 4]} ${textColors[i % 4]} flex items-center justify-center flex-shrink-0`}>
                  <RecommendationIcon icon={rec.icon} />
                </div>
                <div className="min-w-0">
                  <p className={`font-semibold text-sm ${textColors[i % 4]} mb-1`}>{rec.title}</p>
                  <p className="text-xs text-[#596065] leading-relaxed">{rec.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    ) : (
      <div className="text-center py-8">
        <Robot size={36} className="mx-auto mb-3 text-[#acb3b8]" weight="duotone" />
        <p className="text-sm text-[#596065]">Connect Gmail to get personalized recommendations</p>
      </div>
    )}
  </div>
);
